<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { HelpTextTooltip } from '@haskoning/vue-component-library'

import { useMooringPointStore } from '@/stores/mooring_point'

const mooringPointStore = useMooringPointStore()

const { items, selectedItems } = storeToRefs(mooringPointStore)

const isSelected = computed({
  get: () => {
    return items.value.every((item) => selectedItems.value.includes(item))
  },
  set: (value) => {
    mooringPointStore.updateSelectedItems(value, items.value)
  }
})
</script>

<template>
  <tr>
    <th class="text-center" :colspan="3"></th>
    <th class="text-center border-left-grey border-right-grey" colspan="3">Coordinates</th>
    <th class="text-center" colspan="2">Maximum line angle</th>
  </tr>

  <tr>
    <th class="px-1">
      <v-checkbox
        color="primary"
        v-model="isSelected"
        density="compact"
        hide-details
        @click.stop=""
      ></v-checkbox>
    </th>
    <th>
      <HelpTextTooltip
        color="black"
        text="'MD' stands for Mooring Dolphin, 'BD' stands for Berthing Dolphin"
      ></HelpTextTooltip>
      <span class="ml-1"> ID </span>
    </th>
    <th class="text-center" style="width: 150px">Type</th>
    <th class="text-center border-left-grey">X [m]</th>
    <th class="text-center">Y [m]</th>
    <th class="text-center border-right-grey">Z [m CD]</th>
    <th class="text-center">Horizontal (°)</th>
    <th class="text-center">Vertical (°)</th>
  </tr>
</template>
